<div class="row">
  @if (occupation?.typeOfFailure; as typeOfFailure) {
    <div class='col-md-8'>
      <app-label label='Rodzaj awarii:'>
        {{ typeOfFailure }}
      </app-label>
    </div>
  }
</div>
<br>
<dl>
  <dt class="mb-3">
    <strong>Etapy</strong>
  </dt>
  <dd>
    <ol>
      @for (stage of occupation?.stages; track $index) {
        <li>
          <div class='row'>
            <div class='col-md-4'>
              <app-label label='Data od:'>
                {{ stage.startDate | date }}
              </app-label>
            </div>
            <div class='col-md-4'>
              <app-label label='Data do:'>
                {{ stage.endDate | date }}
              </app-label>
            </div>
            <div class='col-md-4'>
              <app-label label='Ilość dni:'>
                {{ stage.dayQuantity }}
              </app-label>
            </div>
            <div class='col-md-4'>
              <app-label label='Geometria:'>
                -
              </app-label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <app-label label="Miejscowość:">
                {{ stage.city }}
              </app-label>
            </div>
            @if (stage.roadNumber; as roadNumber) {
              <div class="col-md-4">
                <app-label label="Numer drogi:">
                  {{ roadNumber }}
                </app-label>
              </div>
            }
            @if (stage.roadName; as roadName) {
              <div class="col-md-4">
                <app-label label="Nazwa drogi:">
                  {{ roadName }}
                </app-label>
              </div>
            }
            @if (stage.street; as street) {
              <div class="col-md-4">
                <app-label label="Ulica:">
                  {{ street }}
                </app-label>
              </div>
            }
          </div>
          <br>
          <div class="row">
            <div class="col-12">
              <p class="mb-2">
                <strong>
                  Działki
                </strong>
              </p>
              <app-parcels-preview [parcels]="stage.parcels">
              </app-parcels-preview>
              <br>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p class="mb-3">
               <strong>
                 Powierzchnie zajęcia
               </strong>
              </p>
            </div>
            <div class="col-md-4">
              <app-label label="Powierzchnia jezdni:">
                {{ stage.roadArea || '-' }} (m<sup>2</sup>)
              </app-label>
            </div>
            <div class="col-md-4">
              <app-label label="Powierzchnia chodnika:">
                {{ stage.sidewalkArea || '-' }} (m<sup>2</sup>)
              </app-label>
            </div>
            <div class="col-md-4">
              <app-label label="Powierzchnia ścieżki rowerowej:">
                {{ stage.bikePathArea || '-' }} (m<sup>2</sup>)
              </app-label>
            </div>
            <div class="col-md-4">
              <app-label label="Powierzchnia rowu przydrożnego:">
                {{ stage.roadsideArea || '-' }} (m<sup>2</sup>)
              </app-label>
            </div>
            <div class="col-md-4">
              <app-label label="Powierzchnia trawnika:">
                {{ stage.greeneryArea || '-' }} (m<sup>2</sup>)
              </app-label>
            </div>
            <div class="col-md-4">
              <app-label label="Powierzchnia pobocza:">
                {{ stage.shoulderArea || '-' }} (m<sup>2</sup>)
              </app-label>
            </div>
          </div>
        </li>
        @if (!$last) {
          <hr>
        }
      }
    </ol>
  </dd>
</dl>
